module.exports = __webpack_public_path__ + "img/More Than Blue_2.38b340a5.jpg";